import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ServicesFormFields } from "web_myplann/Portfolio/Forms/ServicesForm/ServicesFormFields";
import { useEditServicesForm } from "web_myplann/Portfolio/Forms/ServicesForm/useEditServicesForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditServicesFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditServicesForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditServicesFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useEditServicesForm({
		portfolioId,
		portfolio,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<ServicesFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
